import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Shanta Equity\\components\\service\\AllInvestment.jsx");
